import { render, staticRenderFns } from "./FaderPhotoViewer.vue?vue&type=template&id=dfaa8846&scoped=true&"
import script from "./FaderPhotoViewer.vue?vue&type=script&lang=js&"
export * from "./FaderPhotoViewer.vue?vue&type=script&lang=js&"
import style0 from "./FaderPhotoViewer.vue?vue&type=style&index=0&id=dfaa8846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa8846",
  null
  
)

export default component.exports